module.exports = __webpack_public_path__ + "img/1970East-049_WEB-min.72ce06ee.jpg";